import * as React from "react";
import type { IssueStateAggregate } from "@/types/line-editor.types";

export const EmbeddedContext = React.createContext(false);

export function useEmbedded() {
  return React.useContext(EmbeddedContext);
}

export const EditorAggregateContext = React.createContext<IssueStateAggregate | null>(null);

export function useEditorAggregate(): IssueStateAggregate | null {
  return React.useContext(EditorAggregateContext);
}
